var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignVerticalCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290 936V606H80v-60h210V216h100v330h180V336h100v210h210v60H670v210H570V606H390v330H290Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignVerticalCenter);
export default __webpack_public_path__ + "static/media/align_vertical_center.53a1b09c2c2260715efe1912761e3756.svg";
export { ForwardRef as ReactComponent };